import {AbstractControl, ValidatorFn} from '@angular/forms';

import {SortCodeValidatorKey} from './custom-validator-keys';

export function SortCodeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const controlValue = control.value && control.value.toString().trim();

        if (!controlValue) {
            return null;
        }

        return !/^[0-9]{2}-[0-9]{2}-[0-9]{2}$/.test(controlValue) ? {[SortCodeValidatorKey]: true} : null;
    };
}
